import Vue from "vue";
import Vuex from "vuex";
import { APP_NAME } from "@/env";
Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    captions: {},
    loggedUser: null,
    topmenus: [],
    bgColors: null,
    sidemenuData: null,
    hasBreadcrumb: true,
    pageTitle: APP_NAME
  },

  mutations: {
    setCaptions(state, captions) {
      state.captions = captions;
    },
    setUser(state, user) {
      state.loggedUser = user;
    },
    setTopmenus(state, data) {
      state.topmenus = data;
    },
    setBgColors(state, data) {
      state.bgColors = data;
    },
    setSidemenuData(state, data) {
      state.sidemenuData = data;
    },
    setHasBreadcrumb(state, data) {
      state.hasBreadcrumb = data;
    },
    setPageTitle(state, data) {
      state.pageTitle = data;
    }
  },

  actions: {
    setCaptions({ commit }, captions) {
      commit("setCaptions", captions);
    },
    setUser({ commit }, user) {
      commit("setUser", user);
    },
    setTopmenus({ commit }, data) {
      commit("setTopmenus", data);
    },
    setBgColors({ commit }, data) {
      commit("setBgColors", data);
    },
    setSidemenuData({ commit }, data) {
      commit("setSidemenuData", data);
    },
    setHasBreadcrumb({ commit }, data) {
      commit("setHasBreadcrumb", data);
    },
    setPageTitle({ commit }, data) {
      commit("setPageTitle", data);
    }
  },

  getters: {
    captions: state => state.captions,
    loggedUser: state => state.loggedUser,
    topmenus: state => state.topmenus
  }
});
